import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 15000,
});

// Injecter le token JWT dans chaque requête
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('kazo_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Gérer les erreurs globalement
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('kazo_token');
      localStorage.removeItem('kazo_user');
      window.location.href = '/connexion';
    }
    return Promise.reject(err);
  }
);

// ── Auth ──────────────────────────────────────────────────────────
export const authAPI = {
  inscription: (data) => api.post('/auth/inscription', data),
  connexion:   (data) => api.post('/auth/connexion', data),
  moi:         ()     => api.get('/auth/moi'),
  profil:      (data) => api.put('/auth/profil', data),
  motDePasse:  (data) => api.put('/auth/mot-de-passe', data),
};

// ── Annonces ──────────────────────────────────────────────────────
export const annoncesAPI = {
  liste:       (params) => api.get('/annonces', { params }),
  detail:      (id)     => api.get(`/annonces/${id}`),
  creer:       (data)   => api.post('/annonces', data),
  modifier:    (id, data) => api.put(`/annonces/${id}`, data),
  supprimer:   (id)     => api.delete(`/annonces/${id}`),
  vendue:      (id)     => api.put(`/annonces/${id}/vendue`),
  remonter:    (id)     => api.put(`/annonces/${id}/remonter`),
  mesAnnonces: (statut) => api.get('/annonces/user/mes-annonces', { params: { statut } }),
  favori:      (id)     => api.post(`/annonces/${id}/favori`),
  favoris:     ()       => api.get('/annonces/user/favoris'),
  signaler:    (id, data) => api.post(`/annonces/${id}/signaler`, data),
};

// ── Photos ────────────────────────────────────────────────────────
export const photosAPI = {
  upload:      (annonceId, formData) => api.post(`/photos/${annonceId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  supprimer:   (photoId)  => api.delete(`/photos/${photoId}`),
  principale:  (photoId)  => api.put(`/photos/${photoId}/principale`),
};

// ── Messages ──────────────────────────────────────────────────────
export const messagesAPI = {
  liste:        ()          => api.get('/messages'),
  detail:       (id)        => api.get(`/messages/${id}`),
  nouveau:      (data)      => api.post('/messages', data),
  repondre:     (id, data)  => api.post(`/messages/${id}`, data),
  archiver:     (id)        => api.delete(`/messages/${id}/archiver`),
};

// ── Référence ─────────────────────────────────────────────────────
export const refAPI = {
  territoires: () => api.get('/territoires'),
  categories:  () => api.get('/categories'),
};

export default api;
